import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const Layout = () => {
  return (
    <MetaControlField attr="message" />
  );
};

export default Layout;
